export default __webpack_public_path__ + "static/fields-eb12ded86ed689fb7eef3953afd0abe4.mp4";